import MyTable, { MyTableBody, MyTableHeader, MyTableWrapper } from 'components/MyTable';
import Spin from 'components/Spin';
import { WithStyles } from 'decorators/withStyles';
import isEqual from 'lodash/isEqual';
import React, { PureComponent } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { getList } from 'store/Orbita/FiscalDocuments/actions';

import TableItem from './Item';

import type { IMyTableHeaderIndex } from 'components/MyTable/MyTableHeader';
import type { AppStyle } from 'decorators/withStyles';
import type { DispatchProp } from 'react-redux';
import type { ICDFList, IFilterParams } from 'store/Orbita/FiscalDocuments/interfaces';

interface IPropsFromConnect extends DispatchProp<any> {
  isFetching: boolean;
  items: ICDFList;
  total: number;

  getList?: typeof getList;
  classes?: any;
}

interface IProps {
  params: IFilterParams;
}

interface IState {
  headers: IMyTableHeaderIndex[];
}

const style: AppStyle = (theme) => ({
  content: {
    background: 'white',
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    padding: '12px 24px',
    overflow: 'hidden',
  },
  emptyMessage: {
    textAlign: 'center',
    paddingTop: 20,
  },
  totalTd: {
    textAlign: 'right',
    fontSize: 15,
    fontWeight: 'bold',
  },
});

@WithStyles(style, { withTheme: true })
class Table extends PureComponent<IProps & IPropsFromConnect, IState> {
  constructor(props: IProps & IPropsFromConnect) {
    super(props);
    this.state = {
      headers: [{ title: 'Conteúdo' }, { title: 'Registros', numeric: true }, { title: 'Total', numeric: true }, { title: '' }],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps: IProps & IPropsFromConnect) {
    const paramsChanged = !isEqual(prevProps.params, this.props.params);

    if (!paramsChanged) return;
    this.loadData();
  }

  loadData = () => {
    this.props.getList(this.props.params);
  };

  render() {
    const { classes, isFetching, items, total } = this.props;
    const { headers } = this.state;

    return (
      <div className={classes.content}>
        {isFetching && <Spin />}

        {!isFetching && (
          <MyTableWrapper minWidth={800}>
            <MyTable>
              <MyTableHeader index={headers} />
              <MyTableBody>
                {!items.length && (
                  <tr>
                    <td colSpan={headers.length} className={classes.emptyMessage}>
                      Nenhum registro encontrado.
                    </td>
                  </tr>
                )}
                {Array.isArray(items) && items.map((item, index) => <TableItem key={index} data={item} numHeaders={headers.length} />)}
              </MyTableBody>
              <tfoot>
                <tr>
                  <td className={classes.totalTd} colSpan={headers.length - 1}>
                    Total&nbsp;
                    <FormattedNumber value={total} format='BRL' />
                  </td>
                </tr>
              </tfoot>
            </MyTable>
          </MyTableWrapper>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  const items: ICDFList = state.orbita.FiscalDocuments.list || [];

  let totalValue = 0;
  if (items && Array.isArray(items)) {
    items.forEach((it: any) => {
      let result = 0;
      if (it && Array.isArray(it.list)) {
        result = it.list.reduce((acc: any, i: any) => acc + i.value, 0);
      }
      totalValue = totalValue + result;
    });
  }

  return {
    isFetching: state.orbita.FiscalDocuments.list.isFetching,
    items,
    total: totalValue,
  };
}

export default connect<IPropsFromConnect, {}, IProps>(mapStateToProps, { getList })(Table);
